import _ from "underscore";
import vSelect from "vue-select";
import utils from "@/helpers/utils";
import sysMsgs from "@/helpers/system.message";
import ccServices from "@/services/callconnect.services";
import clientesServices from "@/services/dealers.services";
import telephonyServices from "@/services/telephony.services";
export default {
  name: "callConnect",
  components: {
    vSelect
  },
  data() {
    return {
      controller: {
        title: "CallConnect",
        mainRouter: "/tinformacion/callconnect"
      },
      loading: false,
      clients: [],
      clientstmp: [],
      client: null,
      publicaciones: [],
      paginate: ["publicaciones"],
      loadingVirtualPhone: false
    };
  },
  computed: {
    isValid() {
      return this.client.phones.filter(f => f.id > 0).length > 0 || this.client.callConnect;
      //return this.client; //(this.client && this.client.callConnect || this.publicaciones.filter(i => i.carcode > 0).length > 0 ) ? (this.publicaciones.length > 0 || this.publicaciones.filter(i => i.carcode == 0).length > 0) : false;
    },
    validateDays() {
      //Función comprueba si existe al menos un día seleccionado por teléfono.
      var defaultDays = [
        "lunes",
        "martes",
        "miercoles",
        "jueves",
        "viernes",
        "sabado",
        "domingo"
      ];

      var days = _.filter(this.client.phones, p => {
        let d = 0;
        _.each(p, (value, field) => {
          d = _.contains(defaultDays, field) ? (value ? d + 1 : d) : d;
        });
        return d > 0 ? true : false;
      });

      return days.length == this.client.phones.length;
    },
    invalidHours() {
      /*
       *Check si inicio_hora es mayor a fin_hora
       *
       *  @return Boolean
       */
      return this.client.phones.some(h => h.inicio_hora > h.fin_hora);
    },
    invalidMinutes() {
      /*
       *Check si horas son iguales y inicio_minuto es mayor a fin_minuto
       *
       *  @return Boolean
       */
      let arr = this.client.phones.filter(h => h.inicio_hora == h.fin_hora);
      return arr.length > 0
        ? arr.some(h => h.fin_minuto <= h.inicio_minuto)
        : false;
    }
  },
  watch: {
    client: {
      deep: true,
      handler(data) {
        if (data == null) {
          this.clientstmp = this.clients;
          return false;
        }
      }
    },
    "client.cod_cliente": {
      handler(data) {
        if (data) {
          this.paginate.publicaciones.page = 0;
          this.getPublicaciones(this.client);
        }
      }
    }
  },
  created() {
    this.getAll();
  },
  methods: {
    updateRemoteVirtualPhone() {

      sysMsgs
      .getConfirm("Se reasignará el Teléfono Virtual del cliente actual", "info")
      .then(result => {
        if (result.value) {
          this.loadingVirtualPhone = true;
          telephonyServices.setVirtualNumber(this.client.cod_cliente).then(() => {
            this.habilitarCliente(this.client);
            this.loadingVirtualPhone = false;
          }).catch(error => {
            this.loadingVirtualPhone = false;
            console.log('updateRemoteVirtualPhone', error.message);
          })
        }
      });
    },
    setList(search, loading) {
      if (search.toString().trim().length > 0) {
        this.clientstmp = _.filter(this.clients, filter => {
          return (
            filter.nombre_fantasia
              .toString()
              .toLowerCase()
              .indexOf(search.toString().toLowerCase()) > -1 ||
            filter.cod_cliente.toString() == search.toString()
          );
        });
      } else {
        this.clientstmp = this.clients;
      }
    },
    getPublicaciones() {
      this.loading = true;
      ccServices
        .getPublicaciones(this.client.cod_cliente)
        .then(response => {
          this.publicaciones = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          sysMsgs.getMessage(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAll() {
      this.loading = true;
      clientesServices.general
        .getAll(utils.jsonToQueryString({ active: true }))
        .then(response => {
          this.clients = response.data.dealers;
          this.clientstmp = this.clients;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          sysMsgs.getResponseMessage(error.response);
        });
    },
    habilitarCliente(client) {
      this.loading = true;
      ccServices
        .addClient(client)
        .then(response => {
          response.data.callConnect = true;
          this.client = response.data;
          sysMsgs.getMessage("Se ha actualizado el Cliente", "success");                
          ccServices
            .addPublicaciones(this.publicaciones)
            .then(response => {
              this.publicaciones = response.data;
              this.loading = false;
              if (this.publicaciones != this.publicaciones)

                sysMsgs.getMessage(
                  "Se han actualizado los Cardcodes",
                  "success"
                );
            })
            .catch(error => {
              sysMsgs.getResponseMessage(error.response);
              console.log("No se pudieron actualizar los Cardcodes.");
            }).finally(res => {
              this.loading = false;
            });
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          console.log("No se pudo cambiar el estatus del Cliente.");
          this.loading = false;
      });

    },
    deshabilitarCliente(client) {
      this.loading = true;
      ccServices
        .deleteClient(client)
        .then(response => {
          this.client = response.data;
          sysMsgs.getMessage("Se ha deshabilitado el Cliente", "success");
          ccServices
            .deletePublicaciones(this.client)
            .then(() => {
              this.getPublicaciones();
              sysMsgs.getMessage(
                "Se han eliminado los Cardcodes",
                "success"
              );
            })
            .catch(error => {
              this.loading = false;
              sysMsgs.getMessage(
                "Error al eliminar los Cardcodes",
                "error"
              );
            });
        })
        .catch(error => {
          this.loading = false;
          sysMsgs.getResponseMessage(error.response);
        });

    },
    handleHabilitarCliente(client) {
      sysMsgs
        .getConfirm("Se habilitará el cliente actual", "question")
        .then(result => {
          if (result.value) {
            this.habilitarCliente(client);
          }
        });
    },
    handleDeshabilitarCliente(client) {
      sysMsgs
      .getConfirm("Se deshabilitará el cliente actual", "warning")
      .then(result => {
        if (result.value) {
          this.deshabilitarCliente(client);
        }
      });
    },
    getHabilitadas(arr) {
      return arr.filter(i => i.carcode > 0).length;
    }
  }
};
